import { lazy } from 'react'

/**
 * Módulo: Roadmap de desarrollo
 *
 * Tablero interno del equipo que construye CoWork. Vista Now / Next / Later:
 * horizonte (cuándo, en grueso) separado del estado (cómo va). El backlog
 * (Later + Next) se ordena solo por score = Impacto × Confianza ÷ Esfuerzo;
 * fijar (pin) o mover a mano pisa ese orden. Dependencias depende-de / bloquea-a
 * marcan lo bloqueado. Sin librería de drag&drop (mismo criterio que
 * TareasKanban): el movimiento se hace con selects.
 *
 * Interno de Milbrands (`milbrandsInterno: true`). Su ítem del menú ya no lo
 * declara este módulo: está en el grupo «Plataforma Operación», debajo de
 * Debugging (`plataforma-operacion/config.js`).
 * Gating por permiso-módulo 'roadmap' (tras Sincronizar módulos, tildar 'ver'
 * en /permisos para Wizard + Operaciones). Wizard ve todo el catálogo.
 *
 * Bloque 1 (esqueleto): board con estado local + datos semilla. La persistencia
 * en Firestore (colección `roadmapItems`), reglas y acciones finas del catálogo
 * de permisos llegan en el bloque siguiente.
 */
export default {
  id: 'roadmap',
  nombre: 'Roadmap de desarrollo',
  descripcion: 'Tablero Now/Next/Later del equipo que desarrolla CoWork',
  icono: 'list',
  tipo: 'core',
  version: '0.1.0',

  milbrandsInterno: true,
  permisoModulos: ['roadmap'],

  routes: [
    { path: 'roadmap-desarrollo', component: lazy(() => import('./pages/RoadmapPage')) },
  ],

  // El ítem del menú vive en plataforma-operacion/config.js (28-oct-2026).
  menuItems: [],
}
